module.exports = __webpack_public_path__ + "static/media/banner.a167356a.jpg";